<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" md="12">
                <v-row>
                    <v-col cols="12" md="6">
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <th>Date</th>
                                    <td>{{ value ? value.date : null }}</td>
                                </tr>
                                <tr>
                                    <th>Code</th>
                                    <td>{{ value ? value.code : null }}</td>
                                </tr>
                                <tr>
                                    <th>Supplier</th>
                                    <td>
                                        {{
                                            value && value.supplier ? value.supplier.display_name : null
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Mode</th>
                                    <td>{{ value ? value.mode : null }}</td>
                                </tr>
                                <tr>
                                    <th>State</th>
                                    <td>
                                        <PStatus :state="value.state" v-if="value"/>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <th>Paid From</th>
                                    <td>
                                        {{value && value.ledger_account ? value.ledger_account.display_name : null}}
                                    </td>
                                    <th>Paid To</th>
                                    <td>
                                        {{value && value.account ? value.account.display_name : null}}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Paid Amount</th>
                                    <td>
                                        {{ value && value.ledger_account ? formatMoney(value.paid_amount, value.ledger_account.currency.abbreviation) : null }}
                                    </td>
                                    <th>Amount</th>
                                    <td>
                                        {{ value && value.account ? formatMoney(value.amount, value.account.currency.abbreviation) : null }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="value.cheques && value.cheques.length">
            <v-col>
                <v-simple-table dense>
                    <thead>
                        <tr class="secondary">
                            <th>Due Date</th>
                            <th>Cheque #</th>
                            <th>Bank</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d, i) in value.cheques" :key="i">
                            <td>{{d.date}}</td>
                            <td>{{d.number}}</td>
                            <td>{{d.ledger_account ? d.ledger_account.display_name : null}}</td>
                            <td>{{d.ledger_account ? formatMoney(d.amount, d.ledger_account.currency.abbreviation) : null }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="secondary">
                            <th colspan="3">Total</th>
                            <th>{{value && value.cheques && value.ledger_account ? formatMoney(getTotal(value.cheques, "amount"), value.ledger_account.currency.abbreviation) : null}}</th>
                        </tr>
                    </tfoot>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Created By</th>
                            <td>
                                <span v-if="value.created_by">
                                    {{value.created_by.name}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td>{{value.created_at}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" md="4">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Updated By</th>
                            <td>
                                <span v-if="value.updated_by">
                                    {{value.updated_by.name}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Updated At</th>
                            <td>{{value.updated_at}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" md="4">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Posted By</th>
                            <td>
                                <span v-if="value.posted_by">
                                    {{value.posted_by.name}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Posted At</th>
                            <td>{{value.posted_at}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import PStatus from './../common/PStatus'
import { formatMoney } from 'accounting';
import { getTotal } from './../../utils/accounting';

export default {
    name: "PurchasePayment",
    components: {
        PStatus
    },
    props: {
        value: Object,
    },
    methods: {
        getTotal,
        formatMoney(amount, symbol) {
            return formatMoney(amount, {
                symbol,
                precision: 2,
                thousand: ",",
                format: {
                    pos : "%s %v",
                    neg : "%s (%v)",
                    zero: "--"
                }
            });
        }
    }
};
</script>

<style></style>
